// Minimal i18n dictionary for Zabatna. Arabic strings are authoritative —
// English is a translation aid. DO NOT alter Arabic content used verbatim
// from product spec (terms, name "زبطنا").

export const dict = {
  ar: {
    app_name: "زبطنا",
    tagline: "منصة توليد الأبحاث الأكاديمية بالذكاء الاصطناعي",
    hero_title: "أبحاثٌ أكاديمية متقنة — تُسلَّم فور إنجازها",
    hero_sub:
      "اطلب بحثك الأكاديمي، ادفع، ودع زبطنا يولّد لك مسودةً منسّقةً بصيغة Word، مع التحقق من المراجع.",
    cta_register: "ابدأ الآن",
    cta_login: "تسجيل الدخول",
    cta_learn_more: "اعرف المزيد",
    nav_home: "الرئيسية",
    nav_dashboard: "لوحتي",
    nav_admin: "لوحة الإدارة",
    nav_logout: "تسجيل الخروج",
    lang_toggle: "EN",
    // Auth
    register_title: "إنشاء حساب",
    login_title: "تسجيل الدخول",
    email_label: "البريد الإلكتروني",
    email_help:
      "نقبل فقط: gmail.com, outlook.com, hotmail.com, yahoo.com",
    password_label: "كلمة المرور",
    name_label: "الاسم الكامل",
    captcha_label: "تحقق بشري — أجب عن المسألة:",
    refresh_captcha: "تحديث",
    submit_register: "إنشاء الحساب",
    submit_login: "دخول",
    has_account: "لديك حساب؟",
    no_account: "ليس لديك حساب؟",
    // Terms (verbatim Arabic — do not translate)
    terms_disclaimer:
      "تُقدّم المنصة مخرجاتها كأدواتٍ مساعدةٍ استرشاديةٍ تعليمية، ولا نضمن دقتها المطلقة. يتحمل المستخدم المسؤولية الكاملة، وتُخلي المنصة مسؤوليتها عن أي استخدامٍ يخالف سياسات الجهات التعليمية أو المهنية.",
    terms_no_refund:
      "المخرجات رقميةٌ تُسلَّم فور إنجازها، ولا استرداد بعد اكتمال التوليد.",
    // Email verification
    verify_email_title: "تأكيد البريد الإلكتروني",
    verify_email_pending:
      "أرسلنا رابط التأكيد إلى بريدك. يمكنك أيضاً استخدام الرابط أدناه للاختبار:",
    verify_email_success: "تم تأكيد بريدك بنجاح ✓",
    verify_email_fail: "تعذر تأكيد البريد",
    resend_verification: "إعادة إرسال رابط التأكيد",
    // Dashboard tabs
    tab_new_order: "طلب جديد",
    tab_archive: "طلباتي",
    order_title_label: "عنوان البحث",
    order_language_label: "لغة البحث",
    order_methodology_label: "المنهجية البحثية (اختياري)",
    order_appraisal_tool_label: "أداة التقييم النقدي (اختياري)",
    order_page_count_label: "عدد الصفحات",
    order_notes_label: "ملاحظات إضافية (اختياري)",
    order_notes_hint:
      "يُسمح بإضافة / حذف / تعديل الأقسام. لا يُسمح بزيادة عدد الصفحات أو طلب رسوم بيانية معقدة.",
    order_attach_label: "إرفاق ملف (اختياري)",
    order_attach_hint: "PDF أو Word أو نص — بحدّ أقصى 5 ميجابايت. يُستخدم محتواه كسياقٍ مرجعيٍّ للذكاء الاصطناعي.",
    order_attach_btn: "اختر ملفاً",
    order_attach_uploading: "جارٍ الرفع…",
    order_attach_remove: "إزالة",
    order_attach_ready: "تم إرفاق الملف",
    order_attach_too_big: "حجم الملف يتجاوز 5 ميجابايت.",
    order_attach_bad_type: "النوع غير مدعوم. المسموح: PDF, Word, TXT.",
    order_infer_btn: "تحليل العنوان",
    inferred_language: "اللغة المُستنتجة",
    inferred_field: "المجال المُستنتج",
    title_suggestion_label: "اقتراح صياغة أكاديمية للعنوان",
    title_suggestion_accept: "اعتمد العنوان المقترح",
    title_suggestion_keep: "احتفظ بعنواني",
    confirm_summary: "ملخّص الطلب",
    cost_label: "التكلفة",
    confirm_pay_btn: "تأكيد والدفع",
    confirm_terms_no_refund: "أوافق على عدم الاسترداد بعد اكتمال التوليد",
    archive_empty: "لا توجد طلبات بعد",
    status_ready: "جاهز",
    status_processing: "قيد المعالجة",
    status_failed: "فشل",
    status_awaiting_payment: "بانتظار الدفع",
    status_pending: "في الطابور",
    preview_btn: "معاينة",
    download_btn: "تنزيل",
    retry_btn: "إعادة المحاولة",
    delete_btn: "حذف",
    delete_confirm_title: "حذف هذا البحث؟",
    delete_confirm_desc: "سيُحذف البحث من طلباتك نهائياً بما في ذلك ملف Word. لا يمكن التراجع عن هذه العملية.",
    delete_confirm_cta: "نعم، احذفه",
    delete_cancel: "إلغاء",
    delete_success: "تم حذف البحث.",
    resume_payment_btn: "استكمال الدفع",
    share_whatsapp_btn: "واتساب",
    share_whatsapp_message: 'بحثي "{title}" من زبطنا — حمّل النسخة الكاملة (Word):',
    // Admin
    admin_title: "لوحة الإدارة",
    admin_tab_stats: "الإحصائيات",
    admin_tab_users: "المستخدمون",
    admin_tab_billing: "الأسعار والفوترة",
    admin_tab_branding: "الهوية البصرية",
    admin_tab_settings: "الإعدادات العامة",
    stat_users: "المستخدمون",
    stat_papers: "الأبحاث",
    stat_revenue_day: "إيرادات اليوم",
    stat_revenue_month: "إيرادات الشهر",
    save_btn: "حفظ التغييرات",
    cancel_btn: "إلغاء",
    upload_logo: "رفع الشعار",
    remove_logo: "إزالة الشعار",
    actions: "الإجراءات",
    ban: "حظر",
    activate: "تفعيل",
    user_status_banned: "محظور",
    user_status_active: "نشط",
    // Misc
    loading: "جارٍ التحميل…",
    saved: "تم الحفظ",
    error_generic: "حدث خطأ — حاول مجدداً",
  },
  en: {
    app_name: "Zabatna",
    tagline: "AI-Powered Academic Research Generation",
    hero_title: "Polished academic research — delivered the moment it's ready",
    hero_sub:
      "Order your paper, pay, and let Zabatna produce a formatted Word draft with verified references.",
    cta_register: "Get Started",
    cta_login: "Sign In",
    cta_learn_more: "Learn More",
    nav_home: "Home",
    nav_dashboard: "Dashboard",
    nav_admin: "Admin",
    nav_logout: "Logout",
    lang_toggle: "AR",
    register_title: "Create account",
    login_title: "Sign in",
    email_label: "Email",
    email_help:
      "Only allowed: gmail.com, outlook.com, hotmail.com, yahoo.com",
    password_label: "Password",
    name_label: "Full name",
    captcha_label: "Human check — solve:",
    refresh_captcha: "Refresh",
    submit_register: "Create account",
    submit_login: "Sign in",
    has_account: "Have an account?",
    no_account: "No account?",
    terms_disclaimer:
      "تُقدّم المنصة مخرجاتها كأدواتٍ مساعدةٍ استرشاديةٍ تعليمية، ولا نضمن دقتها المطلقة. يتحمل المستخدم المسؤولية الكاملة، وتُخلي المنصة مسؤوليتها عن أي استخدامٍ يخالف سياسات الجهات التعليمية أو المهنية.",
    terms_no_refund:
      "المخرجات رقميةٌ تُسلَّم فور إنجازها، ولا استرداد بعد اكتمال التوليد.",
    verify_email_title: "Verify email",
    verify_email_pending:
      "We sent you a verification link. For testing, you can also use the link below:",
    verify_email_success: "Email verified ✓",
    verify_email_fail: "Verification failed",
    resend_verification: "Resend verification link",
    tab_new_order: "New order",
    tab_archive: "My Orders",
    order_title_label: "Paper title",
    order_language_label: "Paper language",
    order_methodology_label: "Research Methodology (Optional)",
    order_appraisal_tool_label: "Critical Appraisal Tool (Optional)",
    order_page_count_label: "Number of pages",
    order_notes_label: "Additional notes (optional)",
    order_notes_hint:
      "You may add / remove / edit sections. Increasing page count or requesting complex charts is NOT allowed.",
    order_attach_label: "Attach file (optional)",
    order_attach_hint: "PDF, Word or TXT — max 5 MB. Used as reference context for the AI.",
    order_attach_btn: "Choose file",
    order_attach_uploading: "Uploading…",
    order_attach_remove: "Remove",
    order_attach_ready: "File attached",
    order_attach_too_big: "File size exceeds 5 MB.",
    order_attach_bad_type: "Unsupported type. Allowed: PDF, Word, TXT.",
    order_infer_btn: "Analyze Title",
    inferred_language: "Detected language",
    inferred_field: "Detected field",
    title_suggestion_label: "Academic title suggestion",
    title_suggestion_accept: "Use suggested title",
    title_suggestion_keep: "Keep mine",
    confirm_summary: "Order summary",
    cost_label: "Cost",
    confirm_pay_btn: "Confirm & Pay",
    confirm_terms_no_refund: "I agree: no refund after generation completes",
    archive_empty: "No orders yet",
    status_ready: "Ready",
    status_processing: "Processing",
    status_failed: "Failed",
    status_awaiting_payment: "Awaiting payment",
    status_pending: "Queued",
    preview_btn: "Preview",
    download_btn: "Download",
    retry_btn: "Retry",
    delete_btn: "Delete",
    delete_confirm_title: "Delete this paper?",
    delete_confirm_desc: "The paper will be permanently removed from your archive, including the Word file. This action cannot be undone.",
    delete_confirm_cta: "Yes, delete",
    delete_cancel: "Cancel",
    delete_success: "Paper deleted.",
    resume_payment_btn: "Resume Payment",
    share_whatsapp_btn: "WhatsApp",
    share_whatsapp_message: 'My paper "{title}" from Zabatna — download the full Word file:',
    admin_title: "Admin dashboard",
    admin_tab_stats: "Statistics",
    admin_tab_users: "Users",
    admin_tab_billing: "Pricing & Billing",
    admin_tab_branding: "Branding",
    admin_tab_settings: "General settings",
    stat_users: "Users",
    stat_papers: "Papers",
    stat_revenue_day: "Revenue (24h)",
    stat_revenue_month: "Revenue (30d)",
    save_btn: "Save changes",
    cancel_btn: "Cancel",
    upload_logo: "Upload logo",
    remove_logo: "Remove logo",
    actions: "Actions",
    ban: "Ban",
    activate: "Activate",
    user_status_banned: "Banned",
    user_status_active: "Active",
    loading: "Loading…",
    saved: "Saved",
    error_generic: "Something went wrong — try again",
  },
};

export function t(lang, key) {
  return (dict[lang] && dict[lang][key]) || dict.ar[key] || key;
}
